var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLecture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "lecture_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#lecture_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.275 15.775h1.6a1.741 1.741 0 00-.5-1.113 1.665 1.665 0 00-1.1-.512v1.625zm3.95 0c.167 0 .3-.054.4-.162a.47.47 0 00.125-.388 4.488 4.488 0 00-1.287-2.65A4.281 4.281 0 005.825 11.3a.395.395 0 00-.387.112.53.53 0 00-.163.388c0 .15.05.283.15.4.1.117.233.192.4.225.717.1 1.333.408 1.85.925.517.517.833 1.142.95 1.875.033.15.104.28.213.388a.528.528 0 00.387.162zm2.9 0c.15 0 .28-.054.388-.162a.532.532 0 00.162-.388c-.133-1.85-.85-3.421-2.15-4.713-1.3-1.291-2.867-2.004-4.7-2.137a.453.453 0 00-.4.137.553.553 0 00-.15.388c0 .15.05.279.15.387.1.109.233.171.4.188 1.533.133 2.842.742 3.925 1.825 1.083 1.083 1.692 2.392 1.825 3.925.017.15.075.28.175.388a.49.49 0 00.375.162zm-2.65 4.55a.826.826 0 01-.612-.238.826.826 0 01-.238-.612V18.35H4.4c-.467 0-.867-.167-1.2-.5a1.666 1.666 0 01-.5-1.225V5.4c0-.483.167-.892.5-1.225.333-.333.733-.5 1.2-.5h15.2c.467 0 .867.167 1.2.5.333.333.5.742.5 1.225v11.225c0 .483-.167.892-.5 1.225-.333.333-.733.5-1.2.5h-4.225v1.125c0 .25-.08.454-.238.612a.826.826 0 01-.612.238h-5.05zM4.4 16.95h15.2c.083 0 .154-.03.212-.088a.318.318 0 00.088-.237V5.4c0-.1-.03-.18-.088-.238a.289.289 0 00-.212-.087H4.4a.289.289 0 00-.212.087.322.322 0 00-.088.238v11.225c0 .1.03.179.088.237a.287.287 0 00.212.088z",
    fill: "#fff"
  }))));
}
export default SvgLecture;